import {
  USER_AUTHORIZATION_SUBSCRIPTIONS,
  USER_GET_ADMIN_API_TOKEN,
} from "@shared/services/tour/urls/dashboard-urls.ts";
import userGetAdminApiToken from "@shared/services/tour/mockedApis/userGetAdminApiToken.ts";
import userAuthorizationSubscriptions from "@shared/services/tour/mockedApis/userAuthorizationSubscriptions.ts";
import { TourUrlMapping } from "@shared/types/localTypes/tour.ts";

export default {
  [USER_GET_ADMIN_API_TOKEN]: () => userGetAdminApiToken(),
  [USER_AUTHORIZATION_SUBSCRIPTIONS]: () => userAuthorizationSubscriptions(),
} satisfies TourUrlMapping;
